import type { TransactionItemDetail } from 'models';
import { useCallback, useMemo } from 'react';
import { Flag1LineIcon, Modal, message } from 'ui';
import { useCreateAbuseReport } from 'features/report';

export const useReportTestimonial = ({ testimonial }: { testimonial: TransactionItemDetail }) => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: reportTestimonial } = useCreateAbuseReport();

  const confirm = useCallback(() => {
    const handleReportTestimonial = async () => {
      await reportTestimonial(
        { transactionId: testimonial.id },
        {
          onError() {
            message.error('Something went wrong. The report couldn’t be sent.');
          },
          onSuccess() {
            message.success('Testimonial has been reported to admins of your organization.');
          },
        },
      );
    };

    modal.confirm({
      content: 'We will notify admins of your organization',
      icon: <Flag1LineIcon type="info" />,
      okText: 'Report',
      onOk: handleReportTestimonial,
      title: 'Are you sure you want to report this testimonial?',
    });
  }, [modal, reportTestimonial, testimonial.id]);

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
